// The one place page titles are set (FE-118). The router calls setPageTitle after every
// navigation with the route's meta.title; pages whose title depends on loaded data (a
// product or a category) call it again once they know the name.
const SITE_NAME = 'Larkhall Butchers';
const DEFAULT_TITLE = 'Christmas Orders | ' + SITE_NAME;

export function setPageTitle(title) {
    const text = typeof title === 'string' ? title.trim() : '';
    document.title = text ? text + ' | ' + SITE_NAME : DEFAULT_TITLE;
}

// "beef-and-lamb" -> "Beef & Lamb": a readable title while the real name loads.
export function titleFromSlug(slug) {
    return String(slug || '')
        .split('-')
        .filter(Boolean)
        .map(word => word.toLowerCase() === 'and' ? '&' : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}
